// extracted by mini-css-extract-plugin
export var addinsBody = "rRiiv";
export var addinsHeader = "RbDKq";
export var addinsTitle = "SHmTv";
export var container = "wdWLd";
export var rolloutOverridesBody = "nC39a";
export var tipsBody = "PoXtu";